<script>
</script>

<section class="container">
    <h3>Cennik</h3>
    <table>
        <tr>
            <th>Nazwa usługi</th>
            <th>Cena</th>
        </tr>
        <tr>
            <td>psychoterapia indywidualna</td>
            <td>180zł/45min</td>
        </tr>
    </table>
</section>

<style>
    .container {
        font-size: 2em;
        text-align: center;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
    }

    th,
    td {
        padding: 12px;
        text-align: left;
        font-size: 0.7em;
        border-bottom: 1px solid #ddd;
    }
</style>
